import { DataGridBodySkeletonLoader } from '../../common/DataGrid';

export function TargetsTableLoadingState() {
  return (
    <DataGridBodySkeletonLoader
      columns={5}
      rows={5}
      widthRanges={[
        [70, 100],
        [120, 120],
        [30, 30],
        [50, 50],
        [50, 50],
      ]}
      textAlign={['left', 'left', 'left', 'center', 'center']}
    />
  );
}
